import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { isEmpty, toUpper } from 'lodash';

import { Table } from 'components/common';

import { LOGOUT_TRANSACTION_SUMMARY_HEADER_ITEMS } from 'settings/constants/login';
import { formatLogoutTransactionsSummary } from 'utils/logout';

const LogoutTransactionSummaryTable = ({ transactions }) => {
  const { formatMessage } = useIntl();

  const emptyRowText = toUpper(formatMessage({ id: 'dashboard.casa.transactionHistory.noTransactionHistory' }));

  return (
    <Table
      columns={LOGOUT_TRANSACTION_SUMMARY_HEADER_ITEMS}
      rows={formatLogoutTransactionsSummary(transactions)}
      hasRows={!isEmpty(transactions)}
      emptyRowContent={emptyRowText}
    />
  );
};

LogoutTransactionSummaryTable.propTypes = {
  transactions: PropTypes.array.isRequired,
};

export default LogoutTransactionSummaryTable;
